import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import endPoints from '@/redux/constant';
import axios from '@/redux/http';

const initialState = {
  loading: false,
  error: null,
  tiktokData: null,
};

export const getTikTokUserDetailsAPIFn = createAsyncThunk(
  'tiktokSignup/getTikTokUserDetails',
  async (values, { rejectWithValue }) => {
    try {
      const data = await axios({
        method: 'get',
        url: `${endPoints.getTikTokUserDetailsSignup}?code=${encodeURIComponent(values?.code)}&userId=${encodeURIComponent(values?.userId)}&state=${encodeURIComponent(values?.state || '')}`,
      });

      return data?.result ?? data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.response?.data
      );
    }
  }
);

export const tiktokSignupSlice = createSlice({
  name: 'tiktokSignup',
  initialState,
  reducers: {
    clearTiktokSignupData: state => {
      state.tiktokData = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getTikTokUserDetailsAPIFn.pending, state => {
        state.loading = true;
        state.error = null;
        state.tiktokData = null;
      })
      .addCase(getTikTokUserDetailsAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.tiktokData = action.payload;
        state.error = null;
      })
      .addCase(getTikTokUserDetailsAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.tiktokData = null;
      });
  },
});

export const { clearTiktokSignupData } = tiktokSignupSlice.actions;

export default tiktokSignupSlice.reducer;
